import * as React from 'react';
import type {
  UpdateInvoiceDeliveryDatePayload as Payload,
} from 'contracts/tracking-v2/invoices';
import { api, handleApiError } from 'services/api';

export const useUpdateInvoiceDeliveryDate = () => {
  const updateInvoiceDeliveryDate = React.useCallback(async (payload: Payload) => {
    const { invoiceId, ...data } = payload;
    try {
      await api.put(`/tracking-v2/invoices/${invoiceId}/delivery-date`, data);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    updateInvoiceDeliveryDate,
  };
};